module.exports = __webpack_public_path__ + "img/vip-executive-picoas-hotel.756a020f.jpg";